import React from 'react';
import styled from 'styled-components';

import { Container, Label } from 'ui/components/styled';

export const Collapse = ({
  children,
  label,
  labelProps,
  contentProps,
  isOpen = false,
  disabled,
  ...rest
}) => {
  const [open, setOpen] = React.useState(isOpen);
  const [height, setHeight] = React.useState(0);
  const contentRef = React.createRef();

  React.useEffect(() => {
    setHeight(`${contentRef.current?.scrollHeight || 0}px`);
  }, []);

  const toggleOpen = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };

  return (
    <Container height="auto" {...rest}>
      <Heading onClick={toggleOpen} disabled={disabled}>
        <HeadingLabel {...labelProps} mr="xxs">
          {label}
        </HeadingLabel>
        <Icon color={labelProps?.color} open={open} />
      </Heading>
      <Content ref={contentRef} open={open} height={height} {...contentProps}>
        {children}
      </Content>
    </Container>
  );
};

const Heading = styled(Container)`
  flex-direction: row;
  align-items: center;
  width: auto;
  height: auto;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

const HeadingLabel = styled(Label)`
  cursor: inherit;
`;

const Icon = styled.span.attrs(({ theme, color = 'primary' }) => ({
  children: (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5">
      <path
        id="Polygone_11"
        data-name="Polygone 11"
        d="M5,0l5,5H0Z"
        fill={theme.colors[color] || color}
      />
    </svg>
  ),
}))`
  display: flex;
  > svg {
    width: 9px;
  }
  ${({ open }) =>
    !open &&
    `
    transform: rotate(-180deg);
  `}
  transition: transform 300ms;
`;

const Content = styled.div`
  ${({ open, height = 'auto' }) =>
    open
      ? `
      height: ${height};
      margin-bottom: 5px;
  `
      : `
      height: 0px;
  `};
  width: 100%;
  margin-top: 5px;
  overflow: hidden;
  transition: height 300ms;
  font-size: 13px;
  color: ${({ color = 'inherit' }) => color};
  font-weight: 500;
  word-wrap: break-word;
  white-space: pre-wrap;
  letter-spacing: 0.04em;
  line-height: 20px;
`;
